export const FUEL_PROVIDERS = {
    wfs: { name: 'WFS' },
    avfuel: { name: 'AvFuel' },
    valcora: { name: 'Valcora' },
};
export const FUEL_PROVIDER_IDS = Object.keys(FUEL_PROVIDERS);
export function isFuelProviderId(value) {
    return typeof value === 'string' && FUEL_PROVIDER_IDS.includes(value);
}
export function fuelProviderName(providerId) {
    return FUEL_PROVIDERS[providerId].name;
}
//# sourceMappingURL=providers.js.map